import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isWorkingProfessionalUser } from '../../shared/utils/syncUserRole';

function readUserData(): any {
  try {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  } catch {
    return null;
  }
}

export function QueryPreservingRedirect({ to }: { to: string }) {
  const location = useLocation();
  const search = location.search || '';
  return <Navigate to={`${to}${search}`} replace />;
}

export function ProfileRedirect() {
  const location = useLocation();
  const savedMode = localStorage.getItem('activeDashboardMode');
  const user = readUserData();
  const isWP = isWorkingProfessionalUser(user);
  const target =
    savedMode === 'employee'
      ? '/referral-dashboard/profile'
      : isWP
        ? '/referral-dashboard/jobseeker-dashboard/profile'
        : '/jobseeker-dashboard/profile';
  const search = location.search || '';
  return <Navigate to={`${target}${search}`} replace />;
}

export function BookingsRedirect() {
  const location = useLocation();
  const savedMode = localStorage.getItem('activeDashboardMode');
  const user = readUserData();
  const isWP = isWorkingProfessionalUser(user);
  const target =
    savedMode === 'employee'
      ? '/referral-dashboard/my-sessions'
      : isWP
        ? '/referral-dashboard/jobseeker-dashboard/my-sessions'
        : '/jobseeker-dashboard/my-sessions';
  const search = location.search || '';
  return <Navigate to={`${target}${search}`} replace />;
}

export function NetworkRedirect() {
  const location = useLocation();
  const user = readUserData();
  const target = isWorkingProfessionalUser(user) ? '/referral-dashboard' : '/jobseeker-dashboard';
  const search = location.search || '';
  return <Navigate to={`${target}${search}`} replace />;
}

export function NetworkCalendarRedirect() {
  const location = useLocation();
  const user = readUserData();
  const target = isWorkingProfessionalUser(user)
    ? '/referral-dashboard/calendar'
    : '/jobseeker-dashboard/my-sessions';
  const search = location.search || '';
  return <Navigate to={`${target}${search}`} replace />;
}

export function NetworkAnalyticsRedirect() {
  const location = useLocation();
  const user = readUserData();
  const target = isWorkingProfessionalUser(user)
    ? '/referral-dashboard/analytics'
    : '/jobseeker-dashboard';
  const search = location.search || '';
  return <Navigate to={`${target}${search}`} replace />;
}
